import { AccessControl } from 'app/business-logic/security/KnownAccessControls';
import { useAppSelector } from 'app/redux/store';
import { useCallback } from 'react';

/**
 * Hook to check if the user has the required access controls.
 * @returns A function that takes required access controls and a determiner ("some" or "every") and returns a boolean indicating access.
 */
export const useHasAccess = () => {
  const { accessControls: userAccessControls } = useAppSelector(state => state.profile.user);
  return useCallback(
    (required: AccessControl | AccessControl[], determiner: 'some' | 'every' = 'every'): boolean => {
      if (!required || (Array.isArray(required) && required.length === 0)) {
        return true;
      }
      const controls = Array.isArray(required) ? required : [required];
      return determiner === 'some'
        ? controls.some(control => !!userAccessControls[control])
        : controls.every(control => !!userAccessControls[control]);
    },
    [userAccessControls]
  );
};
